var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$().ready(function(){
  $('.mobile-text-slide').slick({
    speed: 300,
    autoplay: true,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});

// Slider 1
$().ready(function(){
  $('.main-div').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    arrows:true,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
$().ready(function(){
  $('.main-div-sale').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    arrows:true,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
// read more

$('.read-more-collection a').click(function() {
  $('.moretext').toggleClass("active");
  if ($('.moreless-button').text() == "Read less") {
    $(this).text("Read more")
  } else {
    $(this).text("Read less")
  }
});

// remove
jQuery(document).ready(function($){
  $(document).on("click",".moreless-button",function(){
      $(this).removeAttr("href").css({'cursor': 'pointer'});
      return true;
  });
});